import { Component, OnInit } from '@angular/core';
import store from './../../../store/store.module';
import { FETCH_LOGIN_DETAIL_REQUESTED } from '../../auth/login/login.actions';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

  public store = store;

  constructor() { }

  ngOnInit() {
    store.dispatch({ type: FETCH_LOGIN_DETAIL_REQUESTED });
  }

}
